<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div *ngIf="!isLoading"
  class="flex flex-row max-[1024px]:flex-wrap items-center gap-6 font-semibold text-[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
  <p (click)="goBack()">Product Shortage</p>
  <p>Shortage Today</p>
</div>

<div class="min-h-max min-w-0 max-w-full">

  <div class="bg-white dark:bg-tileBlack rounded-lg shadow-sm overflow-hidden min-h-[80vh]">

    <div class="max-[640px]:px-4 px-7 py-5 border-b border-gray-100 dark:border-gray-700">
      <h2 class="font-semibold text-[#000000] dark:text-textDark m-0">
        Shortage Today ({{ afterSixPm ? shortageCount.toString().padStart(2, '00') : 0 }})
      </h2>
    </div>

    <div *ngIf="hasData && afterSixPm" class="min-w-0 max-[640px]:!px-3" [class.min-h-[500px]]="isWaiting || shortageCount === 0"
      [class.flex]="isWaiting || shortageCount === 0" [class.items-center]="isWaiting || shortageCount === 0"
      [class.justify-center]="isWaiting || shortageCount === 0" [class.p-6]="!isWaiting && shortageCount > 0">

      <!-- 1. Still waiting for the reveal time -->
      <ng-container *ngIf="isWaiting; else revealed">
        <div class="text-center px-5 py-14">
          <div #lottieContainer class="w-48 h-48 mx-auto"></div>
          <h3 class="text-[30px] font-semibold text-textLight dark:text-textDark mb-4">Please Wait!</h3>
          <p class="text-[16px] font-normal text-[#494949] dark:text-gray-400 max-w-lg mx-auto">
            --If there are any shortages, you will be able to see them by
            <strong class="font-bold text-textLight dark:text-textDark">{{ formattedTime }}</strong>
            on {{ formattedDate }}.--
          </p>
        </div>
      </ng-container>

      <!-- 2. Reveal time has passed -->
      <ng-template #revealed>

        <!-- 2a. No shortages -->
        <ng-container *ngIf="shortageCount === 0; else shortageList">
          <div class="text-center px-5 py-14">
            <p class="text-[16px] font-normal text-[#494949] dark:text-gray-400 mb-6">
              --No Product Shortage for Today--
            </p>
            <img src="/assets/images/NoData.png" alt="No product shortage" class="w-16 h-16 mx-auto" />
          </div>
        </ng-container>

        <!-- 2b. Has shortages -->
        <ng-template #shortageList>
          <div class="flex flex-col gap-3 max-w-full overflow-x-auto pb-2">
            <div *ngFor="let item of shortages"
              class="w-fit grid grid-cols-[56px_180px_100px_100px_150px_100px] items-stretch gap-4 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-3">

              <img [src]="item.image" [alt]="item.name"
                class="w-14 h-14 object-cover rounded-md bg-gray-50 dark:bg-gray-800 self-center" />

              <span class="text-[#000000] font-[600] dark:text-textDark  text-base self-center">
                {{ item.name }}
              </span>

              <div class="bg-[#FEF7EF] dark:bg-orange-900/20 rounded-md px-3 py-2 flex flex-col justify-center">
                <p class="text-xs text-[#000000] font-[400] dark:text-gray-400 m-0">Shortage</p>
                <p class="font-semibold text-[#000000] dark:text-textDark m-0 whitespace-nowrap">
                  {{ formatNumber(item.shortageQty) }} kg
                </p>
              </div>

              <div class="bg-[#E1ECFF] dark:bg-blue-900/20 rounded-md px-3 py-2 flex flex-col justify-center">
                <p class="text-xs text-[#000000] font-[400] dark:text-gray-400 m-0">Assigned</p>
                <p class="font-semibold text-[#000000] dark:text-textDark m-0 whitespace-nowrap">
                  {{ formatNumber(item.assignedQty) }} kg
                </p>
              </div>

              <div class="flex flex-col justify-center">
                <p class="text-xs text-[#000000] font-[400] dark:text-gray-400 m-0 whitespace-nowrap">Market Price per kg</p>
                <p class="font-semibold text-[#000000] dark:text-textDark m-0">
                  Rs. {{ item.marketPrice | number: '1.2-2' }}
                </p>
              </div>

              <button (click)="onView(item)"
                class="bg-[#415CFF] hover:bg-[#415CFF] text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap justify-self-end self-stretch px-6 flex items-center justify-center shadow-md shadow-black/10">
                View
              </button>
            </div>
          </div>
        </ng-template>

      </ng-template>

    </div>

    <div *ngIf="!afterSixPm" class="max-[640px]:px-4 flex flex-col items-center w-full h-screen px-10 py-7 mt-12 ">
       <div #shortageNoDataAnim class="w-48 h-48"></div>
      <p class="text-[#000000] mt-2 mb-6 dark:text-textDark text-[30px] font-[600]">Please Wait!
      </p>
      <p class="text-center font-[400]">--If there are any shortages, you will be able to view them <span
          class="text-[#494949] font-[700]">after 6:00 PM</span> on {{ currentTime | date:'d MMMM y' }}.--</p>
    </div>

    <div *ngIf="!hasData && afterSixPm" class="max-[640px]:px-4 max-[640px]:text-center flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
      <p class="text-[#494949] my-6 dark:text-textDark">--No Product Shortages for today yet--</p>
      <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

  </div>
</div>
